import axios from 'axios'

export const client = axios.create({
  baseURL: process.env.EXPO_PUBLIC_SPARKECOMMERCE_API_URL,
})
